import React, { useEffect, useState } from "react";
import "../../styles/Gallery.css";
import { useNavigate } from "react-router-dom";
import useSEO from "../../hooks/useSeo";

/* Import ONLY optimized 300px images for grid */
function importAll(r) {
  return r.keys().map(r).sort();
}

const gridImages = importAll(
  require.context(
    "../../assets/Images/gallery",
    false,
    /-300\.webp$/, // ✅ use small images in grid
  ),
);

const Gallery = ({ limit }) => {
  useSEO({
    title: "Gallery | Priyadharshinie Public School",
    description:
      "View photos of campus life, classrooms, events, and activities at Priyadharshinie Public School, Bengaluru.",
    url: "https://www.priyadharshiniepublicschool.in/gallery",
  });

  const navigate = useNavigate();
  const [displayedImages, setDisplayedImages] = useState([]);

  useEffect(() => {
    setDisplayedImages(limit ? gridImages.slice(0, limit) : gridImages);
  }, [limit]);

  return (
    <section className="gallery-section" id="gallery">
      <div className="gallery-container">
        <h2 className="gallery-title">Our School Gallery</h2>

        <div className="gallery-grid">
          {displayedImages.map((img, index) => (
            <figure className="gallery-card" key={img}>
              <img
                src={img}
                alt={`School activity ${index + 1}`}
                width="300"
                height="225"
                loading="lazy"
                decoding="async"
              />
            </figure>
          ))}
        </div>

        {limit && gridImages.length > limit && (
          <button
            className="view-more-btn"
            onClick={() => navigate("/gallery")}
          >
            View More →
          </button>
        )}
      </div>
    </section>
  );
};

export default Gallery;
